import React, { useEffect, useState, createElement } from 'react';
import { FadeIn } from '../components/ui/FadeIn';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { Modal } from '../components/ui/Modal';
import { Check, X, Clock, Wind, Brain, Moon, BookOpen, Shield, ArrowRight } from 'lucide-react';
// Declare fbq for TypeScript
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function LandingPage() {
  const [activeModal, setActiveModal] = useState<'terms' | 'privacy' | null>(null);
  // Initialize Meta Pixel and track PageView
  useEffect(() => {
    // Load Meta Pixel script
    ;
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = true;
      t.src = v;
      // Append directly to head instead of inserting before existing script
      b.head.appendChild(t);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    // Initialize pixel with your ID
    window.fbq('init', '894218803203777');
    // Track PageView
    window.fbq('track', 'PageView');
  }, []);
  const handlePurchase = () => {
    // Track AddToCart event before redirect
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Ansiedad en Silencio - Reset de 7 Días',
        content_ids: ['55875645735238'],
        content_type: 'product',
        value: 6.39,
        currency: 'USD'
      });
    }
    // Small delay to ensure tracking fires before redirect
    setTimeout(() => {
      window.location.href = 'https://www.cuidarte360.com/cart/55875645735238:1';
    }, 300);
  };
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen bg-[#F8FAFC] font-sans text-slate-800 selection:bg-teal-100 selection:text-teal-900 flex flex-col" data-id="element-14">
      {/* Navigation / Header */}
      <nav className="w-full py-6 px-4 md:px-8 flex justify-center" data-id="element-15">
        <span className="text-sm font-semibold tracking-widest text-teal-800 uppercase" data-id="element-16">
          Ansiedad en Silencio
        </span>
      </nav>

      <main className="flex-grow" data-id="element-17">
        {/* Hero Section */}
        <section className="relative px-4 pt-12 pb-20 md:pt-20 md:pb-32 overflow-hidden" data-id="element-18">
          <div className="absolute inset-0 -z-10 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-teal-50 via-slate-50 to-white opacity-70" data-id="element-19"></div>

          <div className="max-w-3xl mx-auto text-center" data-id="element-20">
            <FadeIn data-id="element-21">
              <span className="inline-block px-4 py-1.5 mb-6 text-sm font-medium text-teal-800 bg-teal-50 rounded-full border border-teal-100" data-id="element-22">
                Para mujeres que trabajan a turnos
              </span>
              <h1 className="text-4xl md:text-6xl font-bold tracking-tight text-slate-900 mb-6 leading-[1.1]" data-id="element-23">
                Cuando por fin paras… <br className="hidden md:block" data-id="element-24" />
                <span className="text-teal-700" data-id="element-25">y te viene el pico.</span>
              </h1>
              <p className="text-xl md:text-2xl text-slate-600 mb-8 font-light leading-relaxed" data-id="element-26">
                12 minutos al día para bajar el volumen de la ansiedad
                silenciosa.
              </p>

              <div className="max-w-2xl mx-auto mb-10 text-left md:text-center bg-white/50 p-6 rounded-2xl border border-slate-100 backdrop-blur-sm" data-id="element-27">
                <p className="text-slate-600 mb-4" data-id="element-28">
                  Si trabajas a turnos (sanidad, hostelería, comercio), hay un
                  tipo de ansiedad que nadie ve. Atiendes. Resuelves. Sonríes.
                  Aguantas.
                </p>
                <p className="text-slate-600 font-medium" data-id="element-29">
                  Y luego llega tu momento: por fin paras… y tu cuerpo decide
                  que <span className="italic" data-id="element-30">ahora</span> es cuando puede
                  desmoronarse.
                </p>
              </div>

              <div className="flex flex-col items-center gap-3" data-id="element-31">
                <Button onClick={handlePurchase} className="text-lg px-10 py-5 shadow-teal-200/50" data-id="element-32">
                  Descargar ahora - $6.39
                </Button>
                <div className="flex items-center gap-2 text-sm" data-id="element-33">
                  <span className="text-slate-400 line-through" data-id="element-34">$15.00</span>
                  <span className="text-teal-700 font-semibold bg-teal-50 px-2 py-0.5 rounded-md" data-id="element-35">
                    Oferta Especial
                  </span>
                </div>
                <p className="text-sm text-slate-500" data-id="element-36">
                  Acceso inmediato • PDF Digital
                </p>
              </div>
            </FadeIn>
          </div>
        </section>

        {/* Audience Section */}
        <section className="px-4 py-16 md:py-24 bg-white" data-id="element-37">
          <div className="max-w-4xl mx-auto" data-id="element-38">
            <div className="grid md:grid-cols-2 gap-8 md:gap-12" data-id="element-39">
              <FadeIn data-id="element-40">
                <h3 className="text-2xl font-bold text-slate-900 mb-6 flex items-center gap-3" data-id="element-41">
                  <span className="flex items-center justify-center w-8 h-8 rounded-full bg-teal-100 text-teal-700" data-id="element-42">
                    <Check size={18} strokeWidth={3} data-id="element-43" />
                  </span>
                  Esto es para ti si…
                </h3>
                <ul className="space-y-4" data-id="element-44">
                  {["Eres mujer (25–35) y llevas meses con ansiedad 'de fondo'.", 'Te dan picos ocasionales que te asustan (aunque por fuera parezcas tranquila).', 'Trabajas con turnos o días impredecibles y sientes que tu cuerpo nunca baja la guardia.', "Cuando llega la noche, tu cabeza abre el 'juicio' del día y no te deja descansar."].map((item, i) => <li key={i} className="flex items-start gap-3 text-slate-700" data-id="element-45">
                      <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-teal-500 shrink-0" data-id="element-46" />
                      <span className="leading-relaxed" data-id="element-47">{item}</span>
                    </li>)}
                </ul>
              </FadeIn>

              <FadeIn delay={0.2} data-id="element-48">
                <div className="bg-slate-50 p-8 rounded-2xl border border-slate-100 h-full" data-id="element-49">
                  <h3 className="text-xl font-bold text-slate-700 mb-6 flex items-center gap-3" data-id="element-50">
                    <span className="flex items-center justify-center w-8 h-8 rounded-full bg-slate-200 text-slate-500" data-id="element-51">
                      <X size={18} strokeWidth={3} data-id="element-52" />
                    </span>
                    Y no es para ti si…
                  </h3>
                  <ul className="space-y-4" data-id="element-53">
                    {['Buscas diagnóstico, terapia clínica o una solución milagro.', 'No puedes comprometerte a 12 minutos al día durante 7 días.'].map((item, i) => <li key={i} className="flex items-start gap-3 text-slate-600" data-id="element-54">
                        <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-slate-400 shrink-0" data-id="element-55" />
                        <span className="leading-relaxed" data-id="element-56">{item}</span>
                      </li>)}
                  </ul>
                </div>
              </FadeIn>
            </div>
          </div>
        </section>

        {/* The Problem Section */}
        <section className="px-4 py-16 md:py-24 bg-slate-50" data-id="element-57">
          <div className="max-w-3xl mx-auto" data-id="element-58">
            <FadeIn data-id="element-59">
              <div className="text-center mb-12" data-id="element-60">
                <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6" data-id="element-61">
                  El problema no es que <br data-id="element-62" />
                  <span className="text-teal-700" data-id="element-63">"pienses demasiado"</span>
                </h2>
                <p className="text-lg text-slate-600 leading-relaxed" data-id="element-64">
                  El problema es que tu cuerpo está en modo alerta… y la mente
                  intenta explicarlo.
                </p>
              </div>

              <Card className="mb-12 border-l-4 border-l-teal-500" data-id="element-65">
                <p className="text-lg font-medium text-slate-800 mb-4" data-id="element-66">
                  Cuando el sistema nervioso está activado:
                </p>
                <ul className="space-y-3 mb-6" data-id="element-67">
                  <li className="flex items-center gap-3 text-slate-700" data-id="element-68">
                    <Wind className="text-teal-500" size={20} data-id="element-69" />
                    Respiras más alto y corto
                  </li>
                  <li className="flex items-center gap-3 text-slate-700" data-id="element-70">
                    <Shield className="text-teal-500" size={20} data-id="element-71" />
                    Acumulas tensión (mandíbula, pecho, hombros)
                  </li>
                  <li className="flex items-center gap-3 text-slate-700" data-id="element-72">
                    <Brain className="text-teal-500" size={20} data-id="element-73" />
                    Tu mente interpreta todo como amenaza o urgencia
                  </li>
                </ul>
                <p className="text-slate-600 italic border-t border-slate-100 pt-4" data-id="element-74">
                  Y entonces haces lo lógico: intentas calmarte pensando. <br data-id="element-75" />
                  <span className="font-semibold text-teal-700 not-italic" data-id="element-76">
                    Pero pensar no le gana a un cuerpo activado.
                  </span>
                </p>
              </Card>

              <div className="grid md:grid-cols-2 gap-6" data-id="element-77">
                <div className="bg-white p-6 rounded-xl shadow-sm" data-id="element-78">
                  <h4 className="font-bold text-slate-900 mb-2" data-id="element-79">
                    Por qué fallan los "tips"
                  </h4>
                  <p className="text-sm text-slate-600" data-id="element-80">
                    Hoy haces uno, mañana otro. No hay sistema ni repetición que
                    tu cuerpo entienda.
                  </p>
                </div>
                <div className="bg-white p-6 rounded-xl shadow-sm" data-id="element-81">
                  <h4 className="font-bold text-slate-900 mb-2" data-id="element-82">
                    Meditaciones largas
                  </h4>
                  <p className="text-sm text-slate-600" data-id="element-83">
                    En teoría suenan bien; cuando trabajas a turnos y llegas
                    agotada, son una fantasía.
                  </p>
                </div>
                <div className="bg-white p-6 rounded-xl shadow-sm" data-id="element-84">
                  <h4 className="font-bold text-slate-900 mb-2" data-id="element-85">
                    La orden "Relájate"
                  </h4>
                  <p className="text-sm text-slate-600" data-id="element-86">
                    Suena a obligación. Y tu cuerpo responde con más tensión por
                    no conseguirlo.
                  </p>
                </div>
                <div className="bg-white p-6 rounded-xl shadow-sm" data-id="element-87">
                  <h4 className="font-bold text-slate-900 mb-2" data-id="element-88">
                    Sin cierre nocturno
                  </h4>
                  <p className="text-sm text-slate-600" data-id="element-89">
                    Tu mente queda con "pestañas abiertas" y empieza la
                    rumiación justo al tocar la cama.
                  </p>
                </div>
              </div>
            </FadeIn>
          </div>
        </section>

        {/* Product Reveal Section */}
        <section className="px-4 py-16 md:py-24 bg-white overflow-hidden" data-id="element-90">
          <div className="max-w-5xl mx-auto" data-id="element-91">
            <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-92">
              <FadeIn className="order-2 md:order-1" data-id="element-93">
                <div className="relative" data-id="element-94">
                  <div className="absolute -inset-4 bg-teal-100/50 rounded-full blur-3xl -z-10" data-id="element-95"></div>
                  <img src="https://cdn.magicpatterns.com/uploads/4UK1WxLdHGMvRq2ymN2kAb/heylloyd-image-mokup_ansiedad3.png" alt="Ansiedad en Silencio Ebook en Tablet" className="w-full h-auto rounded-2xl shadow-2xl transform md:-rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-96" />
                </div>
              </FadeIn>

              <FadeIn className="order-1 md:order-2" delay={0.2} data-id="element-97">
                <span className="text-teal-600 font-semibold tracking-wide uppercase text-sm" data-id="element-98">
                  Presentación
                </span>
                <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mt-2 mb-6" data-id="element-99">
                  Ansiedad en Silencio <br data-id="element-100" />
                  <span className="text-teal-700" data-id="element-101">Reset de 7 Días</span>
                </h2>
                <p className="text-lg text-slate-600 mb-8" data-id="element-102">
                  Un ebook práctico diseñado para una vida real. Sin mística.
                  Sin perfeccionismo. Sin necesidad de hacerlo "bien".
                </p>

                <div className="space-y-6" data-id="element-103">
                  <div className="bg-slate-50 p-5 rounded-xl border border-slate-100" data-id="element-104">
                    <h3 className="font-bold text-slate-900 mb-3 flex items-center gap-2" data-id="element-105">
                      <Clock className="text-teal-600" size={20} data-id="element-106" />
                      El Protocolo 4-4-4 (12 min)
                    </h3>
                    <ul className="space-y-2 text-slate-700 ml-7" data-id="element-107">
                      <li className="flex items-baseline gap-2" data-id="element-108">
                        <span className="font-bold text-teal-600" data-id="element-109">4 min</span>
                        <span data-id="element-110">Cuerpo (descarga rápida de tensión)</span>
                      </li>
                      <li className="flex items-baseline gap-2" data-id="element-111">
                        <span className="font-bold text-teal-600" data-id="element-112">4 min</span>
                        <span data-id="element-113">Respiración (bajar activación)</span>
                      </li>
                      <li className="flex items-baseline gap-2" data-id="element-114">
                        <span className="font-bold text-teal-600" data-id="element-115">4 min</span>
                        <span data-id="element-116">Mente (descarga mental guiada)</span>
                      </li>
                    </ul>
                  </div>

                  <div className="bg-indigo-50 p-5 rounded-xl border border-indigo-100" data-id="element-117">
                    <h3 className="font-bold text-indigo-900 mb-2 flex items-center gap-2" data-id="element-118">
                      <Moon className="text-indigo-600" size={20} data-id="element-119" />
                      Extra: Cierre del Día
                    </h3>
                    <p className="text-indigo-800 text-sm ml-7" data-id="element-120">
                      3–6 minutos para cortar la rumiación antes de dormir y
                      cerrar las "pestañas" mentales.
                    </p>
                  </div>
                </div>
              </FadeIn>
            </div>
          </div>
        </section>

        {/* What's Included */}
        <section className="px-4 py-16 bg-slate-50" data-id="element-121">
          <div className="max-w-4xl mx-auto" data-id="element-122">
            <FadeIn data-id="element-123">
              <h2 className="text-2xl md:text-3xl font-bold text-center text-slate-900 mb-12" data-id="element-124">
                Qué incluye el Reset
              </h2>
              <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6" data-id="element-125">
                {[{
                icon: BookOpen,
                title: 'Guía completa',
                desc: 'Reset de 7 días, paso a paso.'
              }, {
                icon: Wind,
                title: 'Versiones rápidas',
                desc: 'Para el baño del trabajo, el coche o la cama.'
              }, {
                icon: Brain,
                title: 'Guiones de lectura',
                desc: 'Para cuando no te sale pensar.'
              }, {
                icon: Shield,
                title: 'Plan anti-recaída',
                desc: 'Modo emergencia para semanas de caos.'
              }, {
                icon: Check,
                title: 'FAQ + Glosario',
                desc: 'Respuestas a tus dudas frecuentes.'
              }, {
                icon: Moon,
                title: 'Recursos extra',
                desc: 'Herramientas de apoyo.'
              }].map((item, i) => <Card key={i} className="flex flex-col items-center text-center p-6 hover:shadow-md transition-shadow" data-id="element-126">
                    <div className="w-12 h-12 rounded-full bg-teal-50 text-teal-600 flex items-center justify-center mb-4" data-id="element-127">
                      <item.icon size={24} data-id="element-128" />
                    </div>
                    <h3 className="font-bold text-slate-900 mb-2" data-id="element-129">
                      {item.title}
                    </h3>
                    <p className="text-sm text-slate-600" data-id="element-130">{item.desc}</p>
                  </Card>)}
              </div>
            </FadeIn>
          </div>
        </section>

        {/* Benefits / Outcomes */}
        <section className="px-4 py-16 md:py-24 bg-teal-900 text-white" data-id="element-131">
          <div className="max-w-3xl mx-auto text-center" data-id="element-132">
            <FadeIn data-id="element-133">
              <h2 className="text-3xl font-bold mb-12" data-id="element-134">
                Lo que puedes notar <br data-id="element-135" />
                <span className="text-teal-300 text-xl font-normal" data-id="element-136">
                  (sin promesas mágicas)
                </span>
              </h2>

              <div className="grid sm:grid-cols-2 gap-8 text-left" data-id="element-137">
                <div className="flex gap-4" data-id="element-138">
                  <div className="w-1 h-full bg-teal-500 rounded-full" data-id="element-139"></div>
                  <div data-id="element-140">
                    <h4 className="font-bold text-lg mb-1" data-id="element-141">
                      Picos menos intensos
                    </h4>
                    <p className="text-teal-100 text-sm leading-relaxed" data-id="element-142">
                      O más cortos. Aprendes a surfearlos en lugar de ahogarte.
                    </p>
                  </div>
                </div>
                <div className="flex gap-4" data-id="element-143">
                  <div className="w-1 h-full bg-teal-500 rounded-full" data-id="element-144"></div>
                  <div data-id="element-145">
                    <h4 className="font-bold text-lg mb-1" data-id="element-146">
                      Más sensación de control
                    </h4>
                    <p className="text-teal-100 text-sm leading-relaxed" data-id="element-147">
                      Sabes qué hacer exactamente en el momento en que te sube.
                    </p>
                  </div>
                </div>
                <div className="flex gap-4" data-id="element-148">
                  <div className="w-1 h-full bg-teal-500 rounded-full" data-id="element-149"></div>
                  <div data-id="element-150">
                    <h4 className="font-bold text-lg mb-1" data-id="element-151">Menos rumiación</h4>
                    <p className="text-teal-100 text-sm leading-relaxed" data-id="element-152">
                      Al acostarte, tu cabeza deja de dar vueltas al día.
                    </p>
                  </div>
                </div>
                <div className="flex gap-4" data-id="element-153">
                  <div className="w-1 h-full bg-teal-500 rounded-full" data-id="element-154"></div>
                  <div data-id="element-155">
                    <h4 className="font-bold text-lg mb-1" data-id="element-156">
                      Menos tensión física
                    </h4>
                    <p className="text-teal-100 text-sm leading-relaxed" data-id="element-157">
                      Esa sensación de opresión "pegada" al cuerpo empieza a
                      soltarse.
                    </p>
                  </div>
                </div>
              </div>
            </FadeIn>
          </div>
        </section>

        {/* Pricing Section */}
        <section id="pricing" className="px-4 py-20 md:py-32 bg-white" data-id="element-158">
          <div className="max-w-lg mx-auto" data-id="element-159">
            <FadeIn data-id="element-160">
              <div className="relative bg-white rounded-3xl shadow-2xl border border-slate-100 overflow-hidden" data-id="element-161">
                <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-teal-400 to-teal-600" data-id="element-162"></div>
                <div className="p-8 md:p-12 text-center" data-id="element-163">
                  <h3 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-164">
                    Reset de 7 Días
                  </h3>
                  <p className="text-slate-500 mb-8" data-id="element-165">Ebook Digital + Guías</p>

                  <div className="flex flex-col items-center justify-center mb-8" data-id="element-166">
                    <div className="flex items-center gap-3" data-id="element-167">
                      <span className="text-5xl font-bold text-slate-900" data-id="element-168">
                        $6.39
                      </span>
                      <div className="flex flex-col items-start" data-id="element-169">
                        <span className="text-lg text-slate-400 line-through decoration-slate-400/70" data-id="element-170">
                          $15.00
                        </span>
                        <span className="text-xs font-bold text-teal-700 bg-teal-50 px-2 py-0.5 rounded-full" data-id="element-171">
                          OFERTA ESPECIAL
                        </span>
                      </div>
                    </div>
                    <span className="text-slate-400 text-sm font-medium uppercase tracking-wide mt-2" data-id="element-172">
                      Pago único
                    </span>
                  </div>

                  <ul className="text-left space-y-4 mb-10 max-w-xs mx-auto" data-id="element-173">
                    <li className="flex items-center gap-3 text-slate-700" data-id="element-174">
                      <Check className="text-teal-500 shrink-0" size={20} data-id="element-175" />
                      <span data-id="element-176">Acceso inmediato</span>
                    </li>
                    <li className="flex items-center gap-3 text-slate-700" data-id="element-177">
                      <Check className="text-teal-500 shrink-0" size={20} data-id="element-178" />
                      <span data-id="element-179">Lectura rápida y práctica</span>
                    </li>
                    <li className="flex items-center gap-3 text-slate-700" data-id="element-180">
                      <Check className="text-teal-500 shrink-0" size={20} data-id="element-181" />
                      <span data-id="element-182">Aplicación diaria (12 min)</span>
                    </li>
                  </ul>

                  <Button fullWidth className="text-lg py-4 group" onClick={handlePurchase} data-id="element-183">
                    Descargar ahora
                    <ArrowRight className="ml-2 inline-block transition-transform group-hover:translate-x-1" size={20} data-id="element-184" />
                  </Button>
                  <p className="mt-4 text-xs text-slate-400" data-id="element-185">
                    Pago seguro • Garantía de satisfacción
                  </p>
                </div>
              </div>
            </FadeIn>
          </div>
        </section>

        {/* Final Closing */}
        <section className="px-4 pb-24 pt-10 bg-white" data-id="element-186">
          <div className="max-w-2xl mx-auto text-center" data-id="element-187">
            <FadeIn data-id="element-188">
              <div className="w-16 h-1 bg-teal-100 mx-auto mb-8 rounded-full" data-id="element-189"></div>
              <p className="text-xl md:text-2xl font-medium text-slate-800 mb-6 leading-relaxed" data-id="element-190">
                "Si te reconociste en{' '}
                <span className="text-teal-700 italic" data-id="element-191">
                  cuando por fin paro… y me viene el pico
                </span>
                , esto es exactamente para ti."
              </p>
              <p className="text-lg text-slate-500" data-id="element-192">
                No porque seas débil. <br data-id="element-193" />
                Sino porque llevas demasiado tiempo siendo fuerte.
              </p>
            </FadeIn>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-slate-50 border-t border-slate-200 py-12 px-4 pb-24 md:pb-12" data-id="element-194">
        <div className="max-w-4xl mx-auto text-center" data-id="element-195">
          <p className="text-slate-400 text-sm mb-6" data-id="element-196">
            © {new Date().getFullYear()} Ansiedad en Silencio. Todos los
            derechos reservados.
          </p>
          <div className="flex flex-wrap justify-center gap-6 text-sm" data-id="element-197">
            <button onClick={() => setActiveModal('terms')} className="text-slate-500 hover:text-teal-700 transition-colors" data-id="element-198">
              Términos y Condiciones
            </button>
            <button onClick={() => setActiveModal('privacy')} className="text-slate-500 hover:text-teal-700 transition-colors" data-id="element-199">
              Política de Privacidad
            </button>
          </div>
        </div>
      </footer>

      {/* Sticky Mobile CTA */}
      <div className="fixed bottom-0 left-0 w-full p-4 bg-white/90 backdrop-blur-md border-t border-slate-200 md:hidden z-40" data-id="element-200">
        <Button fullWidth onClick={handlePurchase} className="shadow-lg flex items-center justify-center gap-2" data-id="element-201">
          <span data-id="element-202">Descargar ahora</span>
          <span className="bg-teal-800 text-white text-xs px-1.5 py-0.5 rounded" data-id="element-203">
            $6.39
          </span>
        </Button>
      </div>

      {/* Modals */}
      <Modal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos y Condiciones" data-id="element-204">
        <div className="space-y-4" data-id="element-205">
          <p data-id="element-206">
            <strong data-id="element-207">1. Uso Personal:</strong> Este ebook es para uso personal y
            exclusivo del comprador. Queda prohibida su distribución, venta o
            reproducción total o parcial sin autorización expresa.
          </p>
          <p data-id="element-208">
            <strong data-id="element-209">2. Naturaleza del Producto:</strong> Al tratarse de un
            producto digital de descarga inmediata, no se admiten devoluciones
            una vez descargado el archivo, salvo defecto técnico comprobable.
          </p>
          <p data-id="element-210">
            <strong data-id="element-211">3. Propiedad Intelectual:</strong> Todo el contenido,
            textos, diseño y metodología son propiedad intelectual de "Ansiedad
            en Silencio".
          </p>
          <p data-id="element-212">
            <strong data-id="element-213">4. Descargo de Responsabilidad:</strong> Este material es
            informativo y educativo. No sustituye el consejo, diagnóstico o
            tratamiento médico profesional. Si sufres de ansiedad severa,
            consulta a un especialista.
          </p>
          <p data-id="element-214">
            <strong data-id="element-215">5. Modificaciones:</strong> Nos reservamos el derecho de
            modificar estos términos en cualquier momento. Las actualizaciones
            serán efectivas inmediatamente.
          </p>
        </div>
      </Modal>

      <Modal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" data-id="element-216">
        <div className="space-y-4" data-id="element-217">
          <p data-id="element-218">
            <strong data-id="element-219">1. Recopilación de Datos:</strong> Solo recopilamos los
            datos necesarios para procesar tu compra y entregarte el producto
            (nombre y correo electrónico).
          </p>
          <p data-id="element-220">
            <strong data-id="element-221">2. Uso de la Información:</strong> Tu correo electrónico se
            utilizará para enviarte el ebook y actualizaciones relacionadas con
            el producto. No enviamos spam.
          </p>
          <p data-id="element-222">
            <strong data-id="element-223">3. Protección de Datos:</strong> Tus datos están seguros y
            no se compartirán con terceros, excepto con las plataformas de pago
            necesarias para procesar la transacción.
          </p>
          <p data-id="element-224">
            <strong data-id="element-225">4. Pagos Seguros:</strong> Todas las transacciones se
            procesan a través de pasarelas de pago seguras y encriptadas. No
            almacenamos datos de tarjetas de crédito.
          </p>
          <p data-id="element-226">
            <strong data-id="element-227">5. Tus Derechos:</strong> Puedes solicitar la eliminación de
            tus datos de nuestra base de datos en cualquier momento contactando
            con soporte.
          </p>
        </div>
      </Modal>
    </div>;
}